import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { computed } from "@vue/reactivity";
import { provide, ComputedRef } from "vue";

export type ProvideDisclosure = ComputedRef<{
  open: boolean;
  close: () => void;
  index: number;
}>;

interface ProviderProps {
  open: boolean;
  close: (ref?: HTMLElement) => void;
  index: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Provider',
  props: {
    open: { type: Boolean, default: false },
    close: { type: Function, default: () => {} },
    index: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { open: boolean, close: (ref?: HTMLElement) => void, index: number }



provide<ProvideDisclosure>(
  "disclosure",
  computed(() => {
    return {
      open: props.open,
      close: props.close,
      index: props.index,
    };
  })
);

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})